import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { FacilityConfig } from 'src/environments/environment.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private config: FacilityConfig | null | undefined = null;

  constructor(private http: HttpClient) {}

  loadConfig(): Observable<FacilityConfig> {
    const configFile = environment.envName === 'local' ? '/assets/config-local.json' : '/assets/config.json';
    return this.http.get<FacilityConfig>(configFile).pipe(
      catchError(error => {
        console.error(error);
        return throwError(() => new Error(error));
      })
    );
  }

  setConfig(config: FacilityConfig | undefined) {
    this.config = config;
  }

  getConfig(): FacilityConfig {
    if (!this.config) {
      throw new Error('Config not loaded');
    }
    return this.config;
  }
}
